import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function ReclassifyReducer(state = initialState.reclassifyContent, action: any) {
  switch (action.type) {
    case types.SAVE_RECLASSIFYCONTENT_SUCCESS:
      return action.reclassifyContent;
    default:
      return state;
  }
}
